import axios from 'axios';
import types from '../redux/types';
import routes from '../routes';

const interceptors = ({ history, dispatch }) => {
  axios.interceptors.request.use(
    config => config,
    error => Promise.reject(error),
  );
  axios.interceptors.response.use(
    response => {
      if (response.config.url === '/api/admin/login') {
        const bearerToken = response.data.bearer_token;
        if (bearerToken) {
          axios.defaults.headers.common.Authorization = `Bearer ${bearerToken}`;
        }
        history.replace(routes.Root.path);
      }
      return response;
    },
    error => {
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        history.push(routes.Auth.Login.path);
        dispatch({ type: types.LOGOUT_START });
      }
      return Promise.reject(error);
    },
  );

};

export default interceptors;
